<template>
  <deep-chat
    id="chat-element"
    :connect.prop="connection"
    :textInput.prop="textInputStyles"
    :history.prop="history"
    :messageStyles.prop="messageStyles"
    :auxiliaryStyle.prop="auxiliaryStyle"
    :submitButtonStyles.prop="submitButtonStyles"
    :requestInterceptor.prop="requestInterceptor"
    style="width: 100%; height: 100%; display: block;"
    :style="darkMode 
      ? 'backgroundColor: ' + this.getColor('--darkblue-DEFAULT') + ';borderColor: '+ this.getColor('--darkblue-DEFAULT')
      : 'backgroundColor: ' + this.getColor('--secondary-50') "
  >
    <div>
      <div style="text-align: center; margin-bottom: 8px; font-size: 16px"
        :style="darkMode ? 'color: ' + this.getColor('--darkblue-100') : ''"
        >
        <b>{{$t('ia.title')}}</b>
      </div>
      <div style="font-size: 15px; line-height: 20px; margin-left: 20px; margin-right: 20px">
        <span :style="darkMode ? 'color: ' + this.getColor('--darkblue-100') : ''">
          {{$t('ia.disclaimer')}}
        </span>
      </div>
    </div>

  </deep-chat>
</template>

<script>
import 'deep-chat'
import { getAiApiBaseUrl, joinUrl } from '@/config/runtimeConfig'
import { refreshAccessToken } from '@/services/axiosInstance'
import { shouldRefreshAccessToken } from '@/utils/token'
import '@/scripts/iaComponents/imgCarrousel.js'

export default {
  name: 'AIChat',
  components: {},
  data: function () {
    return {
      history: [],
    }
  },
  computed: {
    connection () {
      // Authorization is injected per-request by requestInterceptor to keep this prop stable
      return {
        url: joinUrl(getAiApiBaseUrl(), 'api/agent/ai/edasneo'),
        method: 'POST',
        stream: true,
      }
    },
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    textInputStyles: function () {
      return {
        styles: {
          text: { color: 'black' },
          container: { maxHeight: '50px', backgroundColor: this.getColor('--darkblue-50') },
          focus: { border: '2px solid #A6ADB9' },
        },
        placeholder: { text: 'Escribe tus dudas aquí...', style: { color: this.getColor('--secondary-DEFAULT') } },
        characterLimit: 300,
      }
    },
    messageStyles: function () {
      return {
        default: {
          // ai: {
          //   bubble: {
          //     backgroundColor: '#4a4e59',
          //     color: 'white'
          //   }
          // },
          user: {
            bubble: {
              background: this.getColor('--primary-800'),
              color: 'white',
              maxWidth: '85%',
            }
          },
          ai: { 
            bubble: { maxWidth: '85%' },
          },
        },
        // loading: {
        //   bubble: { backgroundColor: '#4a4e59', color: 'white' }
        // }
      }
    },
    submitButtonStyles () {
      return {
        submit: {
          svg: {
            styles: {
              default: {
                filter: 'none',
                color: 'var(--secondary-800)'
              }
            }
          }
        },
        alwaysEnabled: true,
        position: 'inside-right'
      }
    },
    getScrollBarsStyle: function () {
      const computedStyle = getComputedStyle(document.documentElement)
      const variableNames = ['--primary-DEFAULT', '--primary-800', '--Component-background-']
      const rootStyle = variableNames.map(x => `${x}: ${computedStyle.getPropertyValue(x)}`).join('; ')
      return `:root { ${rootStyle} } ::-webkit-scrollbar { width: 8px; height: 8px; } ::-webkit-scrollbar-track { background-color: transparent } ::-webkit-scrollbar-thumb { background-color: var(--primary-DEFAULT); border-radius: 20px; } ::-webkit-scrollbar-corner { background: var(--Component-background-); } ::-webkit-scrollbar-thumb:hover { background: var(--primary-800); } ::-webkit-scrollbar-button { height: 2px; width: 2px; }`
    },
    auxiliaryStyle: function () {
      return this.getScrollBarsStyle
    },
    requestInterceptor () {
      return async (requestDetails) => {
        try {
          let token = this.$store.getters['auth/accessToken']
          if (shouldRefreshAccessToken(token)) {
            token = await refreshAccessToken()
          }
          requestDetails.headers = {
            ...(requestDetails.headers || {}),
            Authorization: 'Bearer ' + token
          }
        } catch (e) {
          return { error: this.$t('ia.sessionExpired') }
        }
        return requestDetails
      }
    }
  },
  mounted () {
    const chatElementRef = document.getElementById('chat-element')

    chatElementRef.responseInterceptor = (response) => {
      if (response.html !== undefined) {
        chatElementRef.addMessage({ html: response.html, role: response.role })
        response.html = undefined
      }
      return response
    }

    chatElementRef.htmlClassUtilities = {
      'custom-button': {
        events: {
          click: (event) => {
            const text = event.target.children[0].innerText
            chatElementRef.submitUserMessage(text.substring(1, text.length - 1))
          },
        },
        styles: {
          default: {
            backgroundColor: '#f2f2f2',
            borderRadius: '10px',
            padding: '10px',
            cursor: 'pointer',
            textAlign: 'center',
          },
          hover: { backgroundColor: '#ebebeb' },
          click: { backgroundColor: '#e4e4e4' },
        },
      },
      'custom-button-text': { styles: { default: { pointerEvents: 'none' } } },
    }
  },
  methods: {
    getColor (property) {
      return getComputedStyle(document.querySelector(':root')).getPropertyValue(property)
    },
  }
}
</script>

